(() => {
  const confirm1 = '#withdrawal_form_change_email_confirmation';
  const confirm2 = '#withdrawal_form_invalid_point_confirmation';
  const confirm3 = '#withdrawal_form_cannot_open_mypage_confirmation';
  const confirm4= '#withdrawal_form_valid_shipping_confirmation';
  const confirm5 = '#withdrawal_form_discord_camping_subscription_confirmation';
  const init = () => {

    $('.show-withdrawal-active-button').hide();
    $('.disabled-button-itself').prop('disabled', true);
    $('body')
      .on('click', confirm1, checkValidValue)
      .on('click', confirm2, checkValidValue)
      .on('click', confirm3, checkValidValue)
      .on('click', confirm4, checkValidValue)
      .on('click', confirm5, checkValidValue);
  }

  const checkValidValue = () => {
      if ($(confirm1).prop('checked') && $(confirm2).prop('checked') && $(confirm3).prop('checked') && $(confirm4).prop('checked') && $(confirm5).prop('checked'))   {
     $('.show-withdrawal-active-button').show();
     $('.show-withdrawal-disabled-button').hide();
    }
  }
  $(init);
})();

